import api from "../../Api/feathers-client";

export const getAssignmentData = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log("API getAssignmentData",params);
      // return false;
      let response = await api.service("get-assignment-by-filter").find({
        query: {
          assignmentName: params.assignmentName,
          created_by: params.created_by,
          learners: params.learners,
          class: params.selectedClasses,
          createdAt: params.createdDate,
          site_uuid: params.site_uuid,
          totalData: params.totalData,
          $skip: params.skip,
          $limit: params.limit
        },
      });
      resolve({
        status: 200,
        message: "Assignment Data",
        response
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getUsersByUuid = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find(params);
      resolve({
        status: 200,
        message: "All Users By Uid",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getAssignmentLearnersData = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("get-assignment-by-filter").get('', {
        query: {
          target: params.uid,
          learners: params.learners,
          site_uuid: params.site_uuid,
          $skip: params.skip,
          $limit: params.limit
        },
      });
      resolve({
        status: 200,
        message: "Assignment Learners Data",
        response
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getTasksUuid = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("tasks").find(params);
      resolve({
        status: 200,
        message: "All Users By Uid",
        data: response.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getClassWiseLearners = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("learners-report").get(null, params);
      resolve({
        status: 200,
        message: "Class Wise Learners Data",
        data: response.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getLearnerUsage = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("learners-report").find(params);
      resolve({
        status: 200,
        message: "Learner wise usage data",
        data: response.data,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

//CAll profileactivity, TrainerLeaderBoard, Report/Trainers/index components
export const getTrainerUsageData = async (params) => {
  console.log("params",params);
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("teacher-reports").find(params);
      resolve({
        status: 200,
        message: "Trainer wise usage data",
        data: response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

//CAll profileactivity components
export const getAssignmentAssignData = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignments").find(params);
      resolve({
        status: 200,
        message: "Assignments data",
        data: response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getAssignmentWiseClassData = async (id, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("get-heatmap-data").get(id, params);
      console.log("get-heatmap-data===>", response);
      resolve({
        status: 200,
        message: "Assignment wise Class data",
        classesList: response.classesList,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getAssignmentWiseHeatmapData = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("get-heatmap-data").find(params);
      resolve({
        status: 200,
        message: "Assignment wise heatmap data",
        finalData: response.finalData,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getAssignmentOverviewData = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("get-assignment-overview").find(params);
      resolve({
        status: 200,
        message: "Assignment overview data",
        data: response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getUserLogs = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find(params);
      resolve({
        status: 200,
        message: "User logs data",
        data: response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getAssetsData = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assets").find(params);
      resolve({
        status: 200,
        message: "Assets data",
        data: response.data,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getAssignmentLearnerSummaryLog = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignment-summary-logs").find(params);
      resolve({
        status: 200,
        message: "Assignment learner summary log data",
        data: response.data,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getAssignmentLearnerSummaryLogPrint = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignment-summary-logs").find(params);
      resolve({
        status: 200,
        message: "Assignment learner summary log data",
        data: response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getProgressiveSummaryLogs = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("getProgressiveSummaryLogs").find(params);
      resolve({
        status: 200,
        message: "Assignment progressive summary log data",
        data: response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

export const getAllAssignedBooksByTrainer = async (servicename, queryData) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service(servicename).find({
        query: queryData
      });

      resolve({
        status: 200,
        message: "Books",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

export const getClasswiseProgressReport = async (queryData) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("progress-report").find({
        query: queryData
      });

      resolve({
        status: 200,
        message: "Data",
        data: response,
      });
    } catch (error) {
      resolve({
        status: 404,
        message: "Error",
        data: error,
      });
    }
  });
};
